import { render } from "./ImpactCarousel.vue?vue&type=template&id=09385d2d"
import script from "./ImpactCarousel.vue?vue&type=script&lang=js"
export * from "./ImpactCarousel.vue?vue&type=script&lang=js"

import "./ImpactCarousel.vue?vue&type=style&index=0&id=09385d2d&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__